import { useMemo, useState } from "react";
import Spinner from 'react-bootstrap/Spinner';
import { axiosGetWithHeader } from "../../Common/axios";
import { handleClickColor } from "../../Common/Util";

export function KPCuspalSignificatorPlanetView ({userData}) {
  const [chartData, setChartData] = useState([]);
  const [spinner, setSpinner] = useState('Loading - Cuspal Significators - Planet View');

  useMemo(() => {
    if(userData===null||userData===undefined) {
      setSpinner(null);
      return;
    }
    var clientId = userData.id;
    axiosGetWithHeader("/chart/cuspalsignificatorplanetview/"+clientId,
      (response)=>{
        setChartData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setChartData([]);
        setSpinner(null);
      }
    );
  }, [userData]);

  const tdwidth = {
    width: "15%",
  };

    return(
      <>
        {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
        {  
          chartData===null||chartData.length===0?(
            <></>
          ):(
            <>
        <table class="table table-bordered table-hover align-middle caption-top m-0 p-0 text-center TableFont">
          <caption class="m-0 p-0" ><h5 class="m-0 p-2">Cuspal Significators - Planet View</h5></caption>
          <thead>
            <tr class="p-0 m-0">
              <th class="m-0 p-1 kptable-td">Planet</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>A</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>B</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>C</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>D</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>E</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>F</th> 
            </tr>
          </thead>
          <tbody>
          {
            chartData.map((planet) => (
                <tr class="p-0 m-0"  onClick={handleClickColor}>
                    <th class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[0]}</th>
                    <td class="bg-transparent text-center p-0 kptable-td">{planet[2]}</td>
                    <td class="bg-transparent text-center p-0 kptable-td">{planet[3]}</td>
                    <td class="bg-transparent text-center p-0 kptable-td">{planet[4]}</td>
                    <td class="bg-transparent text-center p-0 kptable-td">{planet[5]}</td>
                    <td class="bg-transparent text-center p-0 kptable-td">{planet[6]}</td>
                    <td class="bg-transparent text-center p-0 kptable-td">{planet[7]}</td>
                </tr>
            ))
        }
            </tbody>  
          </table>
          <span class="m-0 p-0 kpfont">
          A - Planet Star Lord as Cuspal's Sub Lord<br/>
          B - Planet as Cuspal's Sub Lord<br/>
          C - Planet Star Lord as Cuspal's Star Lord<br/>
          D - Planet as Cuspal's Star Lord<br/>
          E - Planet Star Lord's Cuspal Number<br/>
          F - Planet's Cuspal Number<br/>
          </span>
        </>
          )}
        </>  
      );
  }